import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApplicantDetailsResource, ApplicantDetailsResponse } from '@ap/ap-interface-apix-hypotheken-berekening';

@Injectable({
    providedIn: 'root'
})
export class ApplicantDetailsService {
    private readonly applicationDetailsResource = inject(ApplicantDetailsResource);

    getApplicantDetails(dateOfBirth: Date): Observable<ApplicantDetailsResponse> {
        dateOfBirth?.setHours(12, 0, 0, 0);
        return this.applicationDetailsResource.getApplicantDetails(dateOfBirth);
    }
}
